var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"ui-json-format"},[_vm._v("  "),_c('code',{staticClass:"ui-json-format__code",domProps:{"innerHTML":_vm._s(_vm.prettyPrint(_vm.value))}}),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }